import "core-js/modules/es6.array.some";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.set-prototype-of";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
}; // Internal Imports


import { Component } from "../component";
import { AxisPositions } from "../../interfaces";
import { Axis } from "./axis";
import { Tools } from "../../tools";
import { DOMUtils } from "../../services";
import { Threshold } from "../essentials/threshold";

var TwoDimensionalAxes =
/** @class */
function (_super) {
  __extends(TwoDimensionalAxes, _super);

  function TwoDimensionalAxes() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = "2D-axes";
    _this.children = {};
    _this.thresholds = [];
    _this.margins = {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };
    return _this;
  }

  TwoDimensionalAxes.prototype.render = function (animate) {
    var _this = this;

    if (animate === void 0) {
      animate = false;
    }

    var axes = {};
    var axisPositions = Object.keys(AxisPositions);
    var axesOptions = Tools.getProperty(this.model.getOptions(), "axes");
    axisPositions.forEach(function (axisPosition) {
      var axisOptions = axesOptions[AxisPositions[axisPosition]];

      if (axisOptions) {
        axes[AxisPositions[axisPosition]] = true;
      }
    });
    this.configs.axes = axes; // Check the configs to know which axes need to be rendered

    axisPositions.forEach(function (axisPositionKey) {
      var axisPosition = AxisPositions[axisPositionKey];

      if (_this.configs.axes[axisPosition] && !_this.children[axisPosition]) {
        var axisComponent = new Axis(_this.model, _this.services, {
          position: axisPosition,
          axes: _this.configs.axes,
          margins: _this.margins
        }); // Set model, services & parent for the new axis component

        axisComponent.setModel(_this.model);
        axisComponent.setServices(_this.services);
        axisComponent.setParent(_this.parent);
        _this.children[axisPosition] = axisComponent;
      }
    });
    Object.keys(this.children).forEach(function (childKey) {
      var child = _this.children[childKey];
      child.render(animate);
    });
    var margins = {};
    Object.keys(this.children).forEach(function (childKey) {
      var child = _this.children[childKey];
      var axisPosition = child.configs.position; // Grab the invisibly rendered axis' width & height, and set margins
      // Based off of that
      // We draw the invisible axis because of the async nature of d3 transitions
      // To be able to tell the final width & height of the axis when initiaing the transition
      // The invisible axis is updated instantly and without a transition

      var invisibleAxisRef = child.getInvisibleAxisRef();

      var _a = DOMUtils.getSVGElementSize(invisibleAxisRef, {
        useBBox: true
      }),
          width = _a.width,
          height = _a.height;

      var offset;

      if (child.getTitleRef().empty()) {
        offset = 0;
      } else {
        offset = DOMUtils.getSVGElementSize(child.getTitleRef(), {
          useBBox: true
        }).height;
      }

      switch (axisPosition) {
        case AxisPositions.TOP:
          margins.top = height + offset;
          break;

        case AxisPositions.BOTTOM:
          margins.bottom = height + offset;
          break;

        case AxisPositions.LEFT:
          margins.left = width + offset;
          break;

        case AxisPositions.RIGHT:
          margins.right = width + offset;
          break;
      } // Add thresholds


      _this.addAxisThresholds(animate, axisPosition);
    }); // If the new margins are different than the existing ones

    var isNotEqual = Object.keys(margins).some(function (marginKey) {
      return _this.margins[marginKey] !== margins[marginKey];
    });

    if (isNotEqual) {
      this.margins = Object.assign(this.margins, margins);
      Object.keys(this.children).forEach(function (childKey) {
        var child = _this.children[childKey];
        child.margins = _this.margins;
      });
      this.render(true);
    }
  };

  TwoDimensionalAxes.prototype.addAxisThresholds = function (animate, axisPosition) {
    var _this = this;

    var axesOptions = Tools.getProperty(this.model.getOptions(), "axes", axisPosition);
    var thresholds = axesOptions.thresholds;

    if (thresholds) {
      thresholds.forEach(function (thresholdConfig, i) {
        var thresholdComponent = new Threshold(_this.model, _this.services, __assign(__assign({}, thresholdConfig), {
          axisPosition: axisPosition,
          index: i
        }));

        _this.thresholds.push(thresholdComponent);
      });
      this.thresholds.forEach(function (threshold) {
        threshold.setParent(_this.parent);
        threshold.render(animate);
      });
    }
  };

  return TwoDimensionalAxes;
}(Component);

export { TwoDimensionalAxes };